"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getAggregationForContentReport(customProjection) {
    let aggs = {};
    if (customProjection && customProjection.indexOf('contentTypeAggregation') >= 0) {
        aggs = Object.assign({}, aggs, { contentType: {
                terms: {
                    field: 'contentType',
                    size: 30
                }
            } });
    }
    if (Object.keys(aggs).length === 0) {
        return undefined;
    }
    return aggs;
}
exports.getAggregationForContentReport = getAggregationForContentReport;
function getAggregationForRegisterTypeReport(customProjection) {
    let aggs = {};
    if (customProjection && customProjection.indexOf('registerTypeAggregation') >= 0) {
        const completionStatusArrgs = {
            completionStatusAggregrate: {
                terms: {
                    field: 'completionStatus'
                }
            }
        };
        aggs = {
            registerType: {
                terms: {
                    field: 'registerType',
                    size: 30
                },
                aggs: completionStatusArrgs
            }
        };
        if (Object.keys(aggs).length === 0) {
            return undefined;
        }
    }
    return aggs;
}
exports.getAggregationForRegisterTypeReport = getAggregationForRegisterTypeReport;
//# sourceMappingURL=getAggregation.js.map